"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const remove_protocol_1 = require("./maps/remove_protocol");
const to_blank_string_1 = require("./maps/to_blank_string");
const token_pattern_1 = require("./patterns/token_pattern");
const even_odd_split_1 = require("./utilities/even_odd_split");
const reduce_transforms_1 = require("./utilities/reduce_transforms");
const url_transformer_1 = require("./utilities/url_transformer");
exports.urlRedirectStripTokensAndDecode = (leftBracket, rightBracket) => url_transformer_1.default(even_odd_split_1.evenOddSplit(reduce_transforms_1.default([remove_protocol_1.default, decodeURIComponent]), to_blank_string_1.default))(token_pattern_1.default(leftBracket, rightBracket));
exports.default = exports.urlRedirectStripTokensAndDecode;
//# sourceMappingURL=url_redirect_strip_tokens_and_decode.js.map